function collectionCategory() {
  let colJsonEl = document.getElementsByClassName("colJson");
  let collectionTop = [];
  let collectionData = {};

  let pactive = "";
  let sactive = "";
  let elem = document.getElementById("collection_category");
  let choosedCollectionId = elem.dataset.collectionid;
  for (let i = 0; i < colJsonEl.length; i++) {
    if (colJsonEl[i].dataset.parent == "") {
      collectionTop.push({
        id: colJsonEl[i].dataset.id,
        title: colJsonEl[i].dataset.title,
        handle: colJsonEl[i].dataset.handle,
        url: colJsonEl[i].dataset.url,
      });

      if (choosedCollectionId == colJsonEl[i].dataset.id) {
        pactive = colJsonEl[i].dataset.id;
      }
    } else {
      let _parentInfo = colJsonEl[i].dataset.parent.split("/");
      if (collectionData[_parentInfo[_parentInfo.length - 1]] == undefined) {
        collectionData[_parentInfo[_parentInfo.length - 1]] = [];
      }
      collectionData[_parentInfo[_parentInfo.length - 1]].push({
        id: colJsonEl[i].dataset.id,
        title: colJsonEl[i].dataset.title,
        handle: colJsonEl[i].dataset.handle,
        image: colJsonEl[i].dataset.image,
        url: colJsonEl[i].dataset.url,
      });
      if (choosedCollectionId == colJsonEl[i].dataset.id) {
        pactive = _parentInfo[_parentInfo.length - 1];
        sactive = colJsonEl[i].dataset.id;
      }
    }
  }

  function creatSonHtml(key, index) {
    if (collectionData[key] != undefined && collectionData[key].length > 0) {
      let _html = '<div class="category-filters-area-list"><ul class="sec">';
      collectionData[key].forEach((item) => {
        let _activeClass = "";
        if (item.id == sactive) {
          _activeClass = "active";
        }

        _html += `<a href="${item.url}"><li data-handle="${item.handle}" class="${_activeClass}">${item.title}</li></a>`;
        // if (index == 0) {
        firstBranch += `<div class="branchlist">
            <a href="${item.url}">
            <div class="branchlistBox  ${_activeClass}">
            <img src="${item.image}" loading="lazy" />
            <span>${item.title}</span>
            </div>
            </a>
          </div>`;
        // }
      });
      _html += "</ul></div>";
      return _html;
    } else {
      return "";
    }
  }

  let collectionNavHtml = "<ul>";
  let firstHandle = "";
  let firstBranch = "";
  console.log(pactive, sactive);
  collectionTop.forEach((item, index) => {
    let _activeClass = "";
    if (item.id == pactive) {
      if (choosedCollectionId == pactive) {
        _activeClass = "active";
      }
    } else {
      return;
    }
    collectionNavHtml += `<a href="${item.url}"><li data-handle="${item.handle}" class="${_activeClass}">
    ${item.title}
    </li></a>`;
    if (firstHandle == "") firstHandle = item.handle;
    collectionNavHtml += creatSonHtml(item.id, index);
  });
  collectionNavHtml += "</ul>";

  let nav = elem.querySelector(".nav");
  nav.innerHTML = collectionNavHtml;
  elem.dataset.selected = firstHandle;
  elem.querySelector(".branch").innerHTML = firstBranch;
}

collectionCategory();
